import { takeEvery, fork, put, all, call, select } from "redux-saga/effects";
import moment from "moment";
import {
  apiError,
  getVehicles,
  vehiclesListSuccessful,
  isModelVisible,
  InputChangeValue,
  vehicleByIDSuccessful,
  vehicleImagesByIDSuccessful,
  getvehicleImagesByID
} from "./purchaseReleaseSlice";
import {
  getPurchaseDoc,
  getPurchaseCheckApprove,
} from "../purchases/purchasesSlice";
import {
  getVehicleSaleDoc,
  getSalesCheckApprove,
} from "../vehicleCounterSales/vehicleCounterSalesSlice";

import { getMiniVehicles, getMiniVehiclesNonStock } from "../../mini/miniSlice";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";
// Auth Related Methods
import {
  getMiniBrandFamily,
  getMiniModels,
  getMiniVersion,
} from "../../mini/miniSlice";
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
  getList,
  patchEdit,
} from "../../../helpers/Helper";
import { serialize } from "object-to-formdata";

// function* VehiclesGet({ payload }) {
//   var data = payload;
//   var params = {};

//   for (const k in data) {
//     if (Object.hasOwnProperty.call(data, k)) {
//       if (k === "currentSort" || k === "sortOrder") {
//         params.ordering = data.sortOrder + data.currentSort;
//       } else {
//         if (data[k] != "" && k != null && k != "no_of_pages") {
//           params[k] = data[k];
//         }
//       }
//     }
//   }
//   try {
//     const response = yield call(getParamsList, "/masters/vehicles/", params);
//     yield put(vehiclesListSuccessful(response));
//   } catch (error) {
//     yield put(apiError(error));
//   }
// }

function* VehiclesGet({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          if (k == "start_date") {
            params[k] = moment(data[k]).format("YYYY-MM-DD");
          } else if (k == "end_date") {
            params[k] = moment(data[k]).add(1, "days").format("YYYY-MM-DD");
          } else {
            params[k] = data[k];
          }
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/godown/purchasevehicle/release/list/", params);
    yield put(vehiclesListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddVehicles({ payload }) {
  try {
    console.log(payload.id, "LLLLLLLLLLLLLLLLLLL")

    if (payload.id === 0 || payload.id === null || payload.id === undefined) {

      const response = yield call(
        postAdd,
        `/godown/purchasevehicle/release/list/`,
        payload.obj
      );
      if (response.status === 200 || response.status === 201) {
        // const formData = serialize(payload?.profileObj);
        // const response2 = yield call(
        //   postEdit,
        //   "/godown/seizingvehicleimages/" + response.data?.id,
        //   formData
        // );

        // if (response2.status === 200 || response2.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Vehicle released Successfully !
              </p>
            </div>
          ),
        });
        // }
        // yield put(getVehicleEstimation({ page: 1, search: "", page_size: 10 }));
        payload.history.push("/pages/purchase_relese");
      }
      else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Your Vehicle has been not deleted!
              </p>
            </div>
          ),
        });
      }


    } else {

      const response = yield call(
        postEdit,
        "/godown/purchasevehicle/release/" + payload.id + "/",
        payload.obj
      );
      if (response.status === 200 || response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Refund Edited Successfully.!
              </p>
            </div>
          ),
        });
        payload.history.push("/pages/purchase_relese");
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Laon. Please try again!
              </p>
            </div>
          ),
        });
      }
    }
  }
  catch (error) {
    console.log("Error details:", {
      message: error.message,
      code: error.code,
      response: error.response,
      request: !!error.request
    });

    const backendMsg =
      error?.response?.data?.error ??
      error?.response?.data?.message ??
      "Sorry! Something went wrong.";

    let cleanMsg = backendMsg;

    try {
      // Because backend returns "{'error': ['Vehicle is already released.']}"
      const obj = JSON.parse(
        backendMsg.replace(/'/g, '"')
      );
      cleanMsg = obj?.error?.[0] || cleanMsg;
    } catch (_) { }

    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            {cleanMsg}
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }

}



function* DeleteVehicles({ payload }) {
  var areaID = payload;
  try {
    const response = yield call(postDelete, `/godown/seizingvehicle/detail/${areaID}/`);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Vehicle has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getVehicles({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Vehicle has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

function* VehicleValidate({ payload }) {
  try {
    const response = yield call(
      postAdd,
      "/masters/vehicleno/validation/",
      payload
    );
  } catch (error) {
    if (error.response.status == 400) {
      yield put(
        InputChangeValue({
          key: "vehicleno",
          value: "",
        })
      );
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              {error.response.data.error[0]}
            </p>
          </div>
        ),
      });
    } else if (error.response.status == 500) {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Getting from server side issue!
            </p>
          </div>
        ),
      });
    }
    yield put(apiError(error));
  }
}

function* EngineValidate({ payload }) {
  try {
    const response = yield call(
      postAdd,
      "/masters/engineno/validation/",
      payload
    );
  } catch (error) {
    if (error.response.status == 400) {
      yield put(
        InputChangeValue({
          key: "engineno",
          value: "",
        })
      );
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              {error.response.data.error[0]}
            </p>
          </div>
        ),
      });
    } else if (error.response.status == 500) {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Getting from server side issue!
            </p>
          </div>
        ),
      });
    }
    yield put(apiError(error));
  }
}

function* ChassisValidate({ payload }) {
  try {
    const response = yield call(
      postAdd,
      "/masters/chassisno/validation/",
      payload
    );
  } catch (error) {
    if (error.response.status == 400) {
      yield put(
        InputChangeValue({
          key: "chassisno",
          value: "",
        })
      );
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              {error.response.data.error[0]}
            </p>
          </div>
        ),
      });
    } else if (error.response.status == 500) {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Getting from server side issue!
            </p>
          </div>
        ),
      });
    }
    yield put(apiError(error));
  }
}

function* VehicleByID({ payload }) {
  try {
    const response = yield call(
      getParamsList,
      `/godown/purchasevehicle/release/${payload}/`,
    );
    yield put(getMiniBrandFamily({ brand: response.brand?.id }));
    yield put(getMiniModels({ brandfamily: response.brandfamily?.id }));
    yield put(getMiniVersion({ model: response.model?.id }));
    yield put(vehicleByIDSuccessful(response));
    // yield put(getvehicleImagesByID({payload,response2 :response}))

    // yield put(isModelVisible(true));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* VehicleImagesByID({ payload }) {
  try {
    const response = yield call(
      getParamsList,
      `/godown/seizingvehicleimages/detail/${payload?.payload}`,
    );
    yield put(getMiniBrandFamily({ brand: response.brand?.id }));
    yield put(getMiniModels({ brandfamily: response.brandfamily?.id }));
    yield put(getMiniVersion({ model: response.model?.id }));
    yield put(vehicleImagesByIDSuccessful({ response, response2: payload.response2 }));

    // yield put(isModelVisible(true));
  } catch (error) {
    yield put(apiError(error));
  }
}

// function* UpdateFsyncStatus({ payload }) {
//   try {
//     const response = yield call(
//       postEdit,
//       "/masters/vehiclerepost/"  + payload.id, {}
//     );
//     if (response.status === 200 ) {
//       if( response.data.focus_post == true){
//         Modal.success({
//           icon: (
//             <span className="remix-icon">
//               <RiCheckboxCircleLine />
//             </span>
//           ),
//           title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
//           content: (
//             <div>
//               <p className="hp-p1-body hp-text-color-black-80">
//                 Selected Vehicle is successfully synchronised into focus
//               </p>
//             </div>
//           ),
//         });
//       }else{
//         Modal.error({
//           icon: (
//             <span className="remix-icon">
//               <RiAlertLine />
//             </span>
//           ),
//           title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
//           content: (
//             <div>
//               <p className="hp-p1-body hp-text-color-black-80">
//                 Sorry! selected Vehicle is not posted on focus. please try
//                 again!
//               </p>
//             </div>
//           ),
//         });
//       }
//       yield put(getVehicles({ page: 1, search: "", page_size: 10 }));
//     } else {
//       Modal.error({
//         icon: (
//           <span className="remix-icon">
//             <RiAlertLine />
//           </span>
//         ),
//         title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
//         content: (
//           <div>
//             <p className="hp-p1-body hp-text-color-black-80">
//               Sorry! selected Vehicle is not posted on focus. please try
//               again!
//             </p>
//           </div>
//         ),
//       });
//     }
//   } catch (error) {
//     Modal.error({
//       icon: (
//         <span className="remix-icon">
//           <RiAlertLine />
//         </span>
//       ),

//       title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
//       content: (
//         <div>
//           <p className="hp-p1-body hp-text-color-black-80">
//             Sorry! Getting from server side issue!
//           </p>
//         </div>
//       ),
//     });
//     yield put(apiError(error));
//   }
// }


function* UpdateFsyncStatus({ payload }) {
  let vehicleParamsData = yield select(
    (state) => state.vehicles.vehiclesParams
  );
  try {
    const response = yield call(
      getParamsList,
      "/masters/vehiclerepost/" + payload.id,
      {}
    );
    if (response.post_status == true) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Selected Vehicle is successfully synchronised into focus
            </p>
          </div>
        ),
      });
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! selected Vehicle is not posted on focus. please try again!
            </p>
          </div>
        ),
      });
    }
    yield put(getVehicles(vehicleParamsData));
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}


function* watchGetVehicles() {
  yield takeEvery("purchaseRelease/getVehicles", VehiclesGet);
}

export function* watchVehiclesAdd() {
  yield takeEvery("purchaseRelease/vehiclesAdd", AddVehicles);
}

export function* watchVehiclesDelete() {
  yield takeEvery("purchaseRelease/vehiclesDelete", DeleteVehicles);
}

export function* watchVehicleNumberValidate() {
  yield takeEvery("purchaseRelease/vehicleNumberValidate", VehicleValidate);
}

export function* watchEngineNumberValidate() {
  yield takeEvery("purchaseRelease/engineNumberValidate", EngineValidate);
}

export function* watchChassisNumberValidate() {
  yield takeEvery("purchaseRelease/chassisNumberValidate", ChassisValidate);
}
export function* watchGetvehicleByID() {
  yield takeEvery("purchaseRelease/getvehicleByID", VehicleByID);
}
export function* watchGetvehicleImagesByID() {
  yield takeEvery("purchaseRelease/getvehicleImagesByID", VehicleImagesByID);
}

export function* watchFsyncStatusUpdate() {
  yield takeEvery("purchaseRelease/fsyncStatusUpdate", UpdateFsyncStatus);
}
function* PurchaseReleaseSaga() {
  yield all([
    fork(watchGetVehicles),
    fork(watchVehiclesAdd),
    fork(watchVehiclesDelete),
    fork(watchVehicleNumberValidate),
    fork(watchEngineNumberValidate),
    fork(watchChassisNumberValidate),
    fork(watchGetvehicleByID),
    fork(watchGetvehicleImagesByID),
    fork(watchFsyncStatusUpdate),
  ]);
}

export default PurchaseReleaseSaga;
